import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import axios from "axios";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Login from "./Login";
import Shift from "./view/dashboard/Shift";
import Dashboard from "./view/dashboard/Dashboard";
import ComingSoon from "./view/dashboard/ComingSoon";
import Notifications from "./view/dashboard/Notifications";

import UploadJd from "./view/bi_intelligence/upload_jd";
import SearchCandidate from "./view/bi_intelligence/search_candidatedt";
import CandidatesList from "./view/bi_intelligence/candidates_list1";
import SearchRole from "./view/bi_intelligence/search_role";
import SendRecommendedCandidates from "./view/bi_intelligence/serchbyroleid";
import AskPine from "./view/bi_intelligence/ask_pine";
import SearchMapping from "./view/bi_intelligence/Search_mapping";
import ClosureView from "./view/bi_intelligence/closure_list";
import Gamma from "./view/bi_intelligence/gamma";
import NewSearchCandidates from "./view/bi_intelligence/new_search_candidates";
import UniversalSearch from "./view/bi_intelligence/UniversalSearch";
import AdvSearchCandidates from "./view/bi_intelligence/adv_search_candidates";
import ActiveSearches from "./view/bi_intelligence/Active_searches";
import NopoachList from "./view/bi_intelligence/NopoachList";

import PrivateRoute from "./components/PrivateRoute";
import MainLayout from "./components/MainLayout";
import ScrollToTop from "./components/ScrollToTop";

import Employeelist from "./view/employeeinfo/emloyeelist";
import Employeedetails from "./view/employeeinfo/employeedetails";
import MyProfile from "./view/personalinfo/myprofile";
import MyTeam from "./view/personalinfo/myteam";
import TeamView from "./view/personalinfo/teamview";
import Joblist from "./view/employeeinfo/joblist";
import Shelved from "./view/employeeinfo/shelved";
import Closed from "./view/employeeinfo/onboarding/closedjob";
import Registeredusers from "./view/employeeinfo/onboarding/registeredusers";
import RegisteredView from "./view/employeeinfo/onboarding/registeredView";
import Assessment from "./view/employeeinfo/assessment";
import AttendaceInsights from "./view/employeeinfo/attendanceInsights/View";
import EmployeePerformance from "./view/employeeinfo/employee_performance";
import AdminConsole from "./view/employeeinfo/attendanceInsights/AdminConsole";

import ClientList from "./view/client/client_list";
import ClientGrid from "./view/client/client_grid";
// import Addclient from "./view/client/add_client"
import CLientView from "./view/client/view";
import RevenueRisk from "./view/client/revenue_risk";
import Clientrisk from "./view/client/client_risk";

import Newsletter from "./view/newsletter/newsletter";

import Candidate from "./view/candidate/Candidate";
import Candidatelog from "./view/candidate/Candidatelog";
import Candidaterefs from "./view/candidate/Candidaterefs";
import Editstatus from "./view/candidate/edit_status";

import Searchproposal from "./view/role/searchproposal";
import RoleView from "./view/role/role_list";
import RoleNewView from "./view/role/role_new_view";
import FunnelView from "./view/role/FunnelChart";
import GridViewUser from "./view/role/grid_view_user";
import AddNewRole from "./view/role/add_new";
import ContractList from "./view/contract/contract_list";
import RoleDetail from "./view/role/role_detail";
import RoleAtRisk from "./view/role/role_at_risk";

import WorkstationList from "./view/workstation/workstation_list";
import WorkstationView from "./view/workstation/workstation_view";
import SearchUniverse from "./view/workstation/search_universe";
import SearchMap from "./view/workstation/search_map";
import GapAnalysis from "./view/workstation/gap_analysis";
import SearchProposalList from "./view/workstation/searchproposallist";
import PerformanceByYear from "./view/workstation/performance_by_year";

import UsersList from "./view/settings/users_list";
import ModulesList from "./view/settings/modules_list";
import DesignationsList from "./view/settings/designations_list";

import OrderView from "./view/order/order_list";
import OrderDetails from "./view/order/order_details";
import RevenueDetails from "./view/order/revenue_details";
import BusinessGenerated from "./view/order/business_generated";
import Outstanding from "./view/order/outstanding";
import Collection from "./view/order/collection";
import AtRisk from "./view/order/atrisk";

import LeadDashboard from "./view/lead_dashboard/leadDashboard";
import PipeLine from "./view/lead_dashboard/pipeline";
import BdSearchUniverse from "./view/lead_dashboard/ProspectingUniverse";
import PipelineAdminView from "./view/lead_dashboard/adminView";
import Companyinfo from "./view/companyinfo/view";
import Cronjob from "./view/cronjob/view";

import BusinessPulse from "./view/performance/BusinessPulse";
import Overview from "./view/performance/overview";
import Clients from "./view/performance/clients";
import Roles from "./view/performance/roles";
import TeamPerformance from "./view/performance/team_performance";
import Commercial from "./view/performance/commercial";
import SelfGenerationReffered from "./view/performance/self_generation";
import WorkAllocation from "./view/performance/work_allocation";

import Myhr from "./view/personalinfo/myhr";
import AttendanceView from "./view/personalinfo/attendanceView";
import Policy from "./view/personalinfo/policy";
import AddConfirmationFeed from "./view/personalinfo/addConfirmationFeed";

import ForgotPassword from "./forgotPassword";
import ResetPassword from "./resetPassword";
import LeavesView from "./view/leaveinfos/view";

import TravelView from "./view/travelinfos/travelview";

import ReportView from "./view/report/index";
import RevenueAnalysis from "./view/report/pages/revenue_analysis";
import RevenueNetadd from "./view/report/pages/revenue_netadd";
import SectorReport from "./view/report/pages/sector_report";
import SectorAnalysis from "./view/report/pages/sector_analysis";
import RegionReport from "./view/report/pages/region_report";
import RegionAnalysis from "./view/report/pages/region_analysis";
import BusinessGeneration from "./view/report/pages/business_generation";
import UnitPerformance from "./view/report/pages/unit_performance";
import UnitVOBT from "./view/report/pages/unit_vobt";
import UnitNetAdd from "./view/report/pages/unit_netadd";
import UnitChangeLog from "./view/report/pages/unit_changelog";
import ClientAccountAnalysis from "./view/report/pages/client_account_analysis";

import ClientOriginAnalysis from "./view/report/pages/client_origin_analysis";
import ClientQuality from "./view/report/pages/client_quality";
import InvoiceOutstanding from "./view/report/pages/invoice_outstanding";
import InvoiceNotissued from "./view/report/pages/invoice_notissued";
import Invoice2ndPending from "./view/report/pages/invoice_2nd_pending";
import InvoicePipeline from "./view/report/pages/invoice_pipeline";
import InvoiceCollection from "./view/report/pages/invoice_collection";
import InvoiceCanceled from "./view/report/pages/invoice_canceled";
import InvoiceAtrisk from "./view/report/pages/invoice_atrisk";
import NewsletterMonthly from "./view/newsletter/newsletter_monthly";

import AccountView from "./view/account/index";
import AccountOutstanding from "./view/account/outstanding";
import AccountNotissued from "./view/account/notissued";

import ReimbursementsView from "./view/reimbursements/View";
import ReimbursementsApproval from "./view/reimbursements/Reimbursementapproval";

// import Analytics from "./view/performance/analytics";

function TrackPageActivity() {
  const location = useLocation();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) return;

    const trackPageActivity = async () => {
      try {
        const pagePath = location.pathname.replace(/^\/+/, "");

        await axios.post(
          `${API_BASE_URL}/common_controller/track-page`,
          { page: pagePath },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            timeout: 5000,
          },
        );
      } catch (error) {
        console.error(
          "Page tracking error:",
          error.response?.data || error.message,
        );
      }
    };

    trackPageActivity();
  }, [location.pathname, API_BASE_URL]);

  return null;
}

function App() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const requestInterceptor = axios.interceptors.request.use((config) => {
      const token = localStorage.getItem("token");

      if (token && config.url && config.url.startsWith(API_BASE_URL)) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    });

    return () => {
      axios.interceptors.request.eject(requestInterceptor);
    };
  }, [API_BASE_URL]);

  useEffect(() => {
    console.log("Registering Axios Interceptor");
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        const status = error.response?.status;
        console.log("API Error:", error);

        if (status === 401 || status === 403) {
          console.log("Logging out due to auth error:", status);

          localStorage.removeItem("token");
          localStorage.removeItem("user");
          localStorage.removeItem("lastLoginDate");

          window.location.href = "/";
        }

        return Promise.reject(error);
      },
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, []);

  return (
    <Router>
      <TrackPageActivity />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          element={
            <PrivateRoute>
              <MainLayout />
            </PrivateRoute>
          }
        >
          <Route path="/shift" element={<Shift />} />
          <Route path="/dashboard" element={<ComingSoon />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/partner_dashboard" element={<Dashboard />} />
          <Route path="/lead_dashboard">
            <Route path="view" element={<LeadDashboard />} />
            <Route path="pipeline" element={<PipeLine />} />
            <Route path="adminView" element={<PipelineAdminView />} />
            <Route path="searchUniverse" element={<BdSearchUniverse />} />
          </Route>
          <Route path="/newsletter/:id" element={<Newsletter />} />
          <Route path="/cronjob/view" element={<Cronjob />} />
          <Route path="/performance" element={<BusinessPulse />}>
            <Route index element={<Overview />} />
            <Route path="overview" element={<Overview />} />
            <Route path="clients" element={<Clients />} />
            <Route path="roles" element={<Roles />} />
            <Route path="team_performance" element={<TeamPerformance />} />
            <Route path="commercial" element={<Commercial />} />
            <Route
              path="self_generation"
              element={<SelfGenerationReffered />}
            />
            <Route path="work_allocation" element={<WorkAllocation />} />
            {/* <Route path="analytics" element={<Analytics />} /> */}
          </Route>
          <Route path="/business_intelligence">
            <Route path="search_candidates" element={<SearchCandidate />} />
            <Route path="UploadJd" element={<UploadJd />} />
            <Route path="CandidateList" element={<CandidatesList />} />
            <Route path="AskPine" element={<AskPine />}></Route>
            <Route path="SearchRole" element={<SearchRole />}></Route>
            <Route path="ai_presentaions" element={<Gamma />}></Route>
            <Route path="closure" element={<ClosureView />}></Route>
            <Route
              path="new_search_candidates"
              element={<NewSearchCandidates />}
            ></Route>
            <Route
              path="sendRecommendedCandidate/:role_id"
              element={<SendRecommendedCandidates />}
            />
            <Route path="SearchMapping" element={<SearchMapping />}></Route>
            <Route path="universalsearch" element={<UniversalSearch />}></Route>
            <Route path="adv_search" element={<AdvSearchCandidates />}></Route>
            <Route path="active_searches" element={<ActiveSearches />}></Route>
            <Route path="nopoachList" element={<NopoachList />}></Route>
          </Route>
          <Route path="/candidates">
            <Route path="view/:id" element={<Candidate />}></Route>
            <Route path="viewlog/:id" element={<Candidatelog />}></Route>
            <Route path="getRefCheck/:id" element={<Candidaterefs />}></Route>
            <Route
              path="edit_status/:role_id/:candidate_id"
              element={<Editstatus />}
            ></Route>
          </Route>
          <Route path="/personalinfo">
            <Route path="myhr" element={<Myhr />}></Route>
            <Route path="attendanceView" element={<AttendanceView />}></Route>
            <Route path="policy" element={<Policy />}></Route>
            <Route path="myprofile" element={<MyProfile />}></Route>
            <Route path="myteam" element={<MyTeam />}></Route>
            <Route path="teamview/:id" element={<TeamView />}></Route>
            <Route
              path="confirmationFeedback/:userId"
              element={<AddConfirmationFeed />}
            ></Route>
          </Route>
          <Route path="/employeeinfo">
            <Route path="list" element={<Employeelist />}></Route>
            <Route path="view/:id" element={<Employeedetails />}></Route>
            <Route path="joblist" element={<Joblist />}></Route>
            <Route path="shelved" element={<Shelved />}></Route>
            <Route path="closed" element={<Closed />}></Route>
            <Route path="registeredusers" element={<Registeredusers />}></Route>
            <Route
              path="registeredView/:id"
              element={<RegisteredView />}
            ></Route>
            <Route
              path="attendanceinsights"
              element={<AttendaceInsights />}
            ></Route>
            <Route
              path="registeredView/:id"
              element={<RegisteredView />}
            ></Route>
            <Route path="assessment" element={<Assessment />}></Route>
            <Route
              path="employee_performance"
              element={<EmployeePerformance />}
            ></Route>
            <Route path="adminconsole" element={<AdminConsole />}></Route>
          </Route>
          <Route path="/client">
            <Route path="list" element={<ClientList />}></Route>
            <Route path="view/:id" element={<CLientView />}></Route>
            <Route path="revenuerisk" element={<RevenueRisk />}></Route>
            <Route path="clientrisk" element={<Clientrisk />}></Route>
            <Route path="grid" element={<ClientGrid />}></Route>
          </Route>
          <Route path="/role">
            <Route path="list" element={<RoleView />}></Route>
            <Route path="grid_view" element={<RoleNewView />}></Route>
            <Route path="funnel/:roleId" element={<FunnelView />}></Route>
            <Route
              path="grid_view_user/:id?"
              element={<GridViewUser />}
            ></Route>
            <Route path="add_new/:id?" element={<AddNewRole />}></Route>
            <Route path="view/:id" element={<RoleDetail />} />
            <Route path="searchproposal" element={<Searchproposal />} />
            <Route path="risk" element={<RoleAtRisk />}></Route>
            <Route
              path="sendRecommendedCandidate/:role_id"
              element={<SendRecommendedCandidates />}
            ></Route>
          </Route>
          <Route path="/newsletter/:id" element={<Newsletter />} />
          <Route
            path="/newsletter/newsletter_monthly"
            element={<NewsletterMonthly />}
          />
          <Route path="/contract">
            <Route path="list" element={<ContractList />}></Route>
          </Route>
          <Route path="/myhr">
            <Route path="users" element={<Myhr />}></Route>
          </Route>
          <Route path="/workstation">
            <Route path="list" element={<WorkstationList />}></Route>
            <Route path="view/:id" element={<WorkstationView />}></Route>
            <Route
              path="searchproposallist"
              element={<SearchProposalList />}
            ></Route>
            <Route
              path="search_universe/:id"
              element={<SearchUniverse />}
            ></Route>
            <Route path="search_map/:id" element={<SearchMap />}></Route>
            <Route path="gap_analysis/:id" element={<GapAnalysis />}></Route>
            <Route
              path="performancebyyear"
              element={<PerformanceByYear />}
            ></Route>
          </Route>
          <Route path="/settings">
            <Route path="users" element={<UsersList />}></Route>
            <Route path="modules" element={<ModulesList />}></Route>
            <Route path="designations" element={<DesignationsList />}></Route>
          </Route>
          <Route path="/order">
            <Route path="list" element={<OrderView />}></Route>
            <Route path="view/:id" element={<OrderDetails />} />
            <Route path="revenue" element={<RevenueDetails />} />
            <Route path="business" element={<BusinessGenerated />} />
            <Route path="outstanding" element={<Outstanding />} />
            <Route path="collection" element={<Collection />} />
            <Route path="atrisk" element={<AtRisk />} />
          </Route>
          <Route path="/companyinfo">
            <Route path="view/:id" element={<Companyinfo />} />
          </Route>
          <Route path="/report" element={<ReportView />}>
            <Route path="revenue_analysis" element={<RevenueAnalysis />} />
            <Route path="revenue_netadd" element={<RevenueNetadd />} />
            <Route path="sector_report" element={<SectorReport />} />
            <Route path="sector_analysis/:id" element={<SectorAnalysis />} />
            <Route path="region_report" element={<RegionReport />} />
            <Route path="region_analysis/:id" element={<RegionAnalysis />} />
            <Route
              path="business_generation"
              element={<BusinessGeneration />}
            />
            <Route path="unit_performance" element={<UnitPerformance />} />
            <Route path="unit_vobt" element={<UnitVOBT />} />
            <Route path="unit_netadd" element={<UnitNetAdd />} />
            <Route path="unit_changelog" element={<UnitChangeLog />} />
            <Route
              path="client_account_analysis"
              element={<ClientAccountAnalysis />}
            />
            <Route
              path="client_origin_analysis"
              element={<ClientOriginAnalysis />}
            />
            <Route path="client_quality" element={<ClientQuality />} />
            <Route
              path="invoice_outstanding"
              element={<InvoiceOutstanding />}
            />
            <Route path="invoice_notissued" element={<InvoiceNotissued />} />
            <Route path="invoice_2nd_pending" element={<Invoice2ndPending />} />
            <Route path="invoice_atrisk" element={<InvoiceAtrisk />} />
            <Route path="invoice_pipeline" element={<InvoicePipeline />} />
            <Route path="invoice_collection" element={<InvoiceCollection />} />
            <Route path="invoice_canceled" element={<InvoiceCanceled />} />
          </Route>
          <Route path="/leaveinfos">
            <Route path="view" element={<LeavesView />}></Route>
          </Route>
          <Route path="/travelinfos">
            <Route path="view" element={<TravelView />}></Route>
          </Route>

          <Route path="/account">
            <Route path="index" element={<AccountView />}></Route>
            <Route path="outstanding" element={<AccountOutstanding />} />
            <Route path="notissued" element={<AccountNotissued />} />
          </Route>
          <Route path="/reimbursements">
            <Route path="view" element={<ReimbursementsView />}></Route>
            <Route path="approval" element={<ReimbursementsApproval />}></Route>
          </Route>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
